<template>
  <Modal
    :id="id"
    :modalTitle="modalTitle"
    :class="classes"
    :onClose="onClose"
  >
    <div class="row">
      <div
        class="col-12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <img
          v-if="loading"
          src="../../../../../assets/loaderPrimary.svg"
          height="200"
          alt=""
        />
        <iframe
          v-if="!loading && error === ''"
          :src="url + '?' + parameters"
          frameborder="0"
          allowfullscreen
          style="width: 100%; height: 80vh"
          sandbox="allow-same-origin allow-scripts allow-forms"
        />
        <div v-if="!loading && error !== ''" class="text-danger">
          {{ error }}
        </div>
      </div>
    </div>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
</template>

<script>
import axios from "axios";
import Modal from "../../../Shared/Modal.vue";
export default {
  name: "zwipit",
  props: ["id", "modalTitle", "class", "legalIdentifier"],
  data() {
    return {
      classes: this.class,
      url: this.$urlZwipitIframe,
      loading: true,
      parameters: "",
      error: "",
    };
  },
  mounted() {
    this.loadDataUser();
  },
  components: {
    Modal,
  },
  methods: {
    loadDataUser() {
      axios
        .get(`/customer/${this.legalIdentifier}`)
        .then((response) => {
        console.log(response)
          const parameters = {
            platform: "BO",
            name: response.data.name || "",
            surnames: response.data.surnames || "",
            email: response.data.email || "",
            mobile: response.data.mobile || "",
            legalIdentifier: response.data.legalIdentifier || "",
            street: response.data.deliveryAddress.street || "",
            number: response.data.deliveryAddress.number || "",
            postalCode: response.data.deliveryAddress.postalCode || "",
            city: response.data.deliveryAddress.city || "",
            province: response.data.deliveryAddress.province || "",
            birthdate: response.data.birthdate || "",
          };
          const queryParams = new URLSearchParams(parameters).toString();
          this.parameters = queryParams;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.error =
            "Ha ocurrido un error, inténtelo de nuevo mas tarde. Si el problema persiste póngase en contacto con el administrador del sistema.";
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", "");
    },
  },
};
</script>

<style lang="scss"></style>
